import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    publishBtn: {
      marginLeft: theme.spacing(4),
    },
    publishBtnText: {
      paddingLeft: theme.spacing(1),
    },
    progress: {
      width: '1.5rem !important',
      height: '1.5rem !important',
      padding: 0,
      margin: 0,
      color: theme.palette?.neutral?.superLightest,
    },
  })
);
